import React, { useState } from "react";
import { useGet } from "../../services/GetService";
const CardInfo = ({ id }) => {
    const [formInfo, setformInfo] = useGet("/statistics/count-form/" + id);
    return (
        <>
            <p className="lh-1">Eviados: {formInfo.send}</p>
            <p className="lh-1">Error: {formInfo.error}</p>
            <p className="lh-1">Vistos: {formInfo.open}</p>
        </>
    );
};

export default CardInfo;
